import React from 'react';
import {MenuItem} from '@material-ui/core';
import {PaymentActionType} from './PaymentActionHelper';
import Link from '@material-ui/core/Link';
import DonationService from '../../../services/DonationService';

const PaymentDownloadDonationAction = React.forwardRef(({ payment, setMenuAnchor, label }: PaymentActionType, ref: React.Ref<any>) => {
  const downloadDonationReceipt = () => {
    DonationService.downloadDonation(payment.id);
  };

  return (
    <MenuItem
      ref={ref}
      key={payment.id + 'downloadDonation'}
      onClick={() => {
        setMenuAnchor(null);
      }}
    >
      <Link onClick={downloadDonationReceipt} underline="none" color="inherit">
        {label}
      </Link>
    </MenuItem>
  );
});

export default PaymentDownloadDonationAction;
